export default __webpack_public_path__ + "static/media/443.e5b4a38d.png";